import { Component, EventEmitter, forwardRef, Input, OnInit, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-gst-number-input',
  templateUrl: './gst-number-input.component.html',
  styleUrls: ['./gst-number-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => GstNumberInputComponent),
      multi: true
    }
  ]
})
export class GstNumberInputComponent  implements OnInit {

  @Input() number: number = 0;
  @Input() min: number = 0;
  @Input() max: number = Infinity;
  @Output() numberChange = new EventEmitter<number>();

  @Input() isDisabled: boolean = false;

  private onChange: (value: number) => void = () => {};
  private onTouched: () => void = () => {};

  constructor() {}

  ngOnInit() {}

  increment() {
    const newValue = +(+this.number + 0.5).toFixed(2); // ✅ two decimals
    if (newValue <= this.max) {
      this.number = newValue;
      this.emitChanges();
    }
  }

  decrement() {
    const newValue = +(+this.number - 0.5).toFixed(2); // ✅ two decimals
    if (newValue >= this.min) {
      this.number = newValue;
      this.emitChanges();
    }
  }

  onInput(event: any) {
    let value = parseFloat(event.target.value);

    if (isNaN(value)) {
      value = this.min;
    }

    if (value < this.min) {
      this.number = this.min;
    } else if (value > this.max) {
      this.number = this.max;
    } else {
      this.number = +value.toFixed(2); // ✅ enforce 2 decimal places
    }

    this.emitChanges();
  }


  private emitChanges() {
    this.onChange(this.number);
    this.numberChange.emit(this.number);
  }

  writeValue(value: number): void {
    this.number = value;
  }

  registerOnChange(fn: (value: number) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

}
